import React, { useEffect, useRef, useState } from "react";
import CustomInput from "../../CustomInput";
import CustomView from "../../CustomView";

import "./index.scss";

interface ITime {
  hour?: string | number;
  minute?: string | number;
}

type Props = {
  time: ITime;
  isOpen: boolean;
  onChangeTime: (time: ITime) => void;
  setIsOpen: (isOpen: boolean) => void;
};

const CustomHourPiker = (props: Props) => {
  const refActiveHour = useRef<HTMLInputElement | null>(null);
  const [activeHour, setIsActiveHour] = useState(false);

  useEffect(() => {
    document.addEventListener("mousedown", (event: any) => {
      if (!refActiveHour?.current?.contains(event.target)) {
        props.setIsOpen(false);
      }
    });
  }, []);

  if (!props.isOpen) return null;
  return (
    <section id="custom-hour-piker-content" ref={refActiveHour}>
      <CustomView.Row className="modal-content">
        <CustomView.Column medium={6} className="time-container">
          <CustomInput
            type="number"
            minLength={1}
            maxLength={2}
            value={props.time?.minute ? String(props.time?.minute) : "00"}
            onValueChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              var thisNumber = Number(event.target.value);
              if (thisNumber <= 60 && thisNumber >= 0)
                if (thisNumber < 10)
                  props.onChangeTime({
                    ...props.time,
                    minute: String("0" + thisNumber),
                  });
                else
                  props.onChangeTime({
                    ...props.time,
                    minute: String(thisNumber),
                  });
            }}
          />
        </CustomView.Column>
        <CustomView.Column medium={6} className="time-container">
          <CustomInput
            type="number"
            minLength={1}
            maxLength={2}
            value={props.time?.hour ? String(props.time?.hour) : "00"}
            onValueChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              var thisNumber = Number(event.target.value);

              if (thisNumber <= 24 && thisNumber >= 0)
                if (thisNumber < 10)
                  props.onChangeTime({
                    ...props.time,
                    hour: String("0" + thisNumber),
                  });
                else
                  props.onChangeTime({
                    ...props.time,
                    hour: String(thisNumber),
                  });
            }}
          />
        </CustomView.Column>
      </CustomView.Row>
    </section>
  );
};

export default CustomHourPiker;
